
import { HDate } from '@hebcal/core';

export let getFormattedDate = (d = null, isDayOffset = true) => {
  let dayOffset = parseInt(localStorage.getItem("dayOffset") || "0", 10); 

  const date = d ? new Date(d) : new Date();
  if(isDayOffset){
    date.setDate(date.getDate() + dayOffset);
  }else{
    date.setDate(date.getDate());
  }

  const day = String(date.getDate()).padStart(2, '0');    
  const month = String(date.getMonth() + 1).padStart(2, '0'); 
  const year = date.getFullYear();

  const res = day + month + year;
  return res;
};


export function isFullMonth() {
  const dayOffset = parseInt(localStorage.getItem("dayOffset") || "0", 10);
  
  const jsDate = new Date();
  jsDate.setDate(jsDate.getDate() + dayOffset + 1);
  
  const hdate = new HDate(jsDate);

  if(hdate.dd == 1){
    return false;
  }

  return true;
}
